import { useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import { _classes } from "../utilities/helpers";
import styles from "../../styles/partials/_reservation-dropdown.scss";

const cl = _classes(styles);

const EMBED_SRC = "https://www.sevenrooms.com/widget/embed.js";

const SevenRoomsWidget = ({ venueId }) => {
  const triggerIdRef = useRef(`sr-res-${uuidv4()}`);

  useEffect(() => {
    const triggerId = triggerIdRef.current;

    const initWidget = () => {
      if (!window.SevenroomsWidget) return;
      window.SevenroomsWidget.init({
        venueId,
        triggerId,
        type: "reservations",
        styleButton: false,
      });
    };

    let script = document.querySelector(`script[src="${EMBED_SRC}"]`);
    if (!script) {
      script = document.createElement("script");
      script.src = EMBED_SRC;
      script.async = true;
      script.addEventListener("load", initWidget, { once: true });
      document.body.appendChild(script);
    } else {
      script.addEventListener("load", initWidget, { once: true });
    }

    initWidget();
  }, [venueId]);

  return (
    <div className={cl("header__reserve")}>
      <div
        id={triggerIdRef.current}
        className={`reserve ${cl("header__reserve")}`}
        role="button"
        tabIndex={0}
        aria-label="Reserve"
      >
        RESERVE
      </div>
    </div>
  );
};

export default SevenRoomsWidget;
